import '../components/NamePages/NamePages.css';

const NotFound404 = () => (
  <div className="NamePages">
    <p>not found error: 404</p>
  </div>
);

export default NotFound404;
